// For use in Carpenter theme only. Ported from NextJS with differing fontSizes
// We can share once we have the same 16px root fontSize using the NextJS values

import { ComponentStyleConfig } from '@chakra-ui/react';

export const ProductPrice: ComponentStyleConfig = {
   parts: ['container', 'price', 'compareAtPrice', 'proBadgeHorizontal', 'proBadgeVertical'],
   baseStyle: {
      container: {
         display: 'flex',
         alignSelf: 'flex-start',
      },
      price: {
         fontWeight: 'semibold',
         display: 'flex',
         alignItems: 'center',
      },
      proBadgeVertical: {
         h: '4',
         mr: '1.5',
         display: 'inline-block',
      },
      compareAtPrice: {
         color: 'gray.500',
         textDecor: 'line-through',
      },
   },
   sizes: {
      'extra-small': {
         price: {
            fontSize: 'sm',
         },
         compareAtPrice: {
            fontSize: 'sm',
         },
         proBadgeHorizontal: {
            py: '3px',
            fontSize: '10px',
            lineHeight: '4',
         },
         proBadgeVertical: {
            h: 4,
         },
      },
      small: {
         price: {
            fontSize: 'md',
         },
         compareAtPrice: {
            fontSize: 'md',
         },
         proBadgeHorizontal: {
            py: '3px',
            fontSize: '13px',
            lineHeight: '4',
         },
         proBadgeVertical: {
            h: 4,
         },
      },
      medium: {
         price: {
            fontSize: 'lg',
         },
         compareAtPrice: {
            fontSize: 'md',
         },
         proBadgeHorizontal: {
            py: '3px',
            fontSize: '13px',
            lineHeight: '4',
         },
         proBadgeVertical: {
            h: 4,
         },
      },
      large: {
         price: {
            fontSize: 'xl',
         },
         compareAtPrice: {
            fontSize: 'lg',
         },
         proBadgeHorizontal: {
            py: '3px',
            fontSize: 'md',
            lineHeight: '5',
         },
         proBadgeVertical: {
            h: 5,
         },
      },
   },
};
